import {_UPPER_SNAKE_CASE} from '@js-dot/core';

/**
 * 값이 단어 식별문구인지 시험 합니다.
 * @param id
 * @constructor
 */
export function isWordId(id: string) {
	return _UPPER_SNAKE_CASE.test(id);
}